export default function myAccountStatement() {
    return {
        studentTermsList:[],
        studentCharges: [],
        studentReceipts: [],
        studentRefunds: [],
        passedAcademicTerm: '',
        passedAcademicYear: '',
        passedPeopleCodeId: '',
        selectedQuarter: [],     
        totalCharges: '',
        totalReceipts: '',
        totalRefunds:'',
        showErrorMesage: false,       
        showLoader: false,
        detailPageUrl: '',
        handleQuarterClick() {

            var parts = this.selectedQuarter.split("/");

            this.passedAcademicTerm = parts[1];
            this.passedAcademicYear = parts[0] ;
            this.detailPageUrl = document.getElementById('hdnPageUrl').value + '?academicYear=' + this.passedAcademicYear + '&academicTerm=' + this.passedAcademicTerm;

        },
        bindStudentTermsList() {

            fetch('/api/StudentAPI/GetStudentSeasons', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        Array.prototype.push.apply(this.studentTermsList, response.seasons)
                        this.passedAcademicTerm = response.seasons[0].academicTerm;
                        this.passedAcademicYear = response.seasons[0].academicYear;
                        this.detailPageUrl = document.getElementById('hdnPageUrl').value + '?academicYear=' + this.passedAcademicYear + '&academicTerm=' + this.passedAcademicTerm;

                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },
       
        
        init() {

            //this.passedAcademicTerm = this.passedAcademicTerm ? this.passedAcademicTerm : "SPRING";
            //this.passedAcademicYear = this.passedAcademicYear ? this.passedAcademicYear : new Date().getFullYear();
            this.bindStudentTermsList();

        }
    }
}